import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import {
  EnvelopeSimple,
  CheckCircle,
  Clock,
  Warning,
} from '@phosphor-icons/react';

const StatCard = ({ icon: Icon, color, bg, label, value, testid }) => (
  <Card className="border-slate-200" data-testid={testid}>
    <CardContent className="pt-4">
      <div className="flex items-center gap-3">
        <div className={`p-2 ${bg} rounded-lg`}>
          <Icon size={20} className={color} />
        </div>
        <div>
          <p className="text-xs text-slate-500">{label}</p>
          <p className="text-xl font-bold">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const InvitationsStatsCards = ({ invitations }) => {
  const pending = invitations.filter((i) => i.status === 'pending').length;
  const accepted = invitations.filter((i) => i.status === 'accepted').length;
  const expired = invitations.filter((i) => i.status === 'expired').length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <StatCard
        icon={EnvelopeSimple}
        color="text-indigo-600"
        bg="bg-indigo-100"
        label="Total Invited"
        value={invitations.length}
        testid="stat-total-invited"
      />
      <StatCard
        icon={Clock}
        color="text-amber-600"
        bg="bg-amber-100"
        label="Pending"
        value={pending}
        testid="stat-pending"
      />
      <StatCard
        icon={CheckCircle}
        color="text-green-600"
        bg="bg-green-100"
        label="Accepted"
        value={accepted}
        testid="stat-accepted"
      />
      <StatCard
        icon={Warning}
        color="text-slate-600"
        bg="bg-slate-100"
        label="Expired"
        value={expired}
        testid="stat-expired"
      />
    </div>
  );
};

export default InvitationsStatsCards;
